export const GET_TRIP_FAIL = "GET_TRIP_FAIL";
export const GET_TRIP_SUCCESS = "GET_TRIP_SUCCESS";
export const GET_TRIP_REQUEST = "GET_TRIP_REQUEST";
